import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import endpoints from "../../services/endpoints";
import { TripCard, TripCardBody, TripCardImg, TripCardMeta, TripCardName, TripStatusPill, TripsGrid, } from "./profile.style";
import { formatTripCardMeta, getTripCardEmoji } from "./profile.utils";
import { getImageUrl } from "../../utils/helpers/functions";
var ProfileTripsGrid = function (_a) {
    var trips = _a.trips;
    var navigate = useNavigate();
    if (!trips.length) {
        return (_jsx("p", { style: { fontSize: 13, color: "#7a7368", margin: 0 }, children: "No trips yet." }));
    }
    return (_jsx(TripsGrid, { children: trips.map(function (trip) { return (_jsxs(TripCard, { type: "button", onClick: function () {
                return navigate("".concat(endpoints.web.tripDetails, "/").concat(trip.tripId));
            }, children: [_jsxs(TripCardImg, { "$bg": trip.coverImageUrl
                        ? "url(".concat(getImageUrl(trip.coverImageUrl), ") center/cover")
                        : undefined, children: [!trip.coverImageUrl && getTripCardEmoji(trip.tripName), _jsx(TripStatusPill, { "$variant": trip.statusLabel, children: trip.statusLabel })] }), _jsxs(TripCardBody, { children: [_jsx(TripCardName, { children: trip.tripName }), _jsx(TripCardMeta, { children: formatTripCardMeta(trip) })] })] }, trip.tripId)); }) }));
};
export default ProfileTripsGrid;
